import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconFactory$1 = /*@__PURE__*/ proxyCustomElement(class WppIconFactory extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-factory", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.06049 2.1001H5.59084C6.60869 2.1001 7.4488 2.89617 7.50355 3.91257L8.14849 15.8845C8.20758 16.9813 7.33417 17.9031 6.23578 17.9031H3.41554C2.31716 17.9031 1.44374 16.9813 1.50283 15.8845L2.14778 3.91257C2.20253 2.89618 3.04263 2.1001 4.06049 2.1001ZM4.06049 3.53673C3.80602 3.53673 3.596 3.73575 3.58231 3.98985L2.93736 15.9618C2.92259 16.236 3.14095 16.4664 3.41554 16.4664H6.23578C6.51038 16.4664 6.72873 16.236 6.71396 15.9618L6.06902 3.98985C6.05533 3.73575 5.8453 3.53673 5.59084 3.53673H4.06049ZM10.0632 16.4664H9.06967C8.97818 17.0117 8.73225 17.5066 8.37746 17.9031H16.3451C17.5352 17.9031 18.5 16.9383 18.5 15.7481V5.45225C18.5 5.16172 18.325 4.8998 18.0566 4.78862C17.7882 4.67743 17.4792 4.73889 17.2738 4.94433L13.7113 8.50686V5.45225C13.7113 5.16172 13.5363 4.8998 13.2679 4.78862C12.9995 4.67743 12.6905 4.73889 12.4851 4.94433L8.72114 8.70831L8.825 10.6362L12.2747 7.18642V10.241C12.2747 10.5316 12.4497 10.7935 12.7181 10.9047C12.9865 11.0159 13.2955 10.9544 13.5009 10.749L17.0634 7.18642V15.7481C17.0634 16.1448 16.7418 16.4664 16.3451 16.4664H15.9998L16.0002 13.2607C16.0002 12.5995 15.4642 12.0635 14.803 12.0635H11.2607C10.5996 12.0635 10.0636 12.5995 10.0636 13.2607L10.0632 16.4664ZM11.4998 16.4664H14.5632L14.5636 13.5001H11.5002L11.4998 16.4664Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-factory-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-factory", "wpp-icon-factory-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-factory-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-factory-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconFactory$1);
      }
      break;
  } });
}

const WppIconFactory = WppIconFactory$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconFactory, defineCustomElement };
